var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMakeAdmin = function SvgMakeAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.556 5.555a3.556 3.556 0 1 1-7.112 0 3.556 3.556 0 0 1 7.112 0zM11.021 14.494c.109 1.322.637 2.53 1.221 3.508h-8.02c-1.416 0-2.223-.444-2.223-1.778C1.999 12.667 6 10 9.999 10c1.598 0 3.197.426 4.54 1.164l-2.024.867c-.885.38-1.589 1.313-1.494 2.463z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.697 12.584 3 1.286c.184.079.306.26.289.459-.192 2.332-2.349 4.597-3.171 5.382a.454.454 0 0 1-.631 0c-.822-.784-2.979-3.05-3.171-5.382a.466.466 0 0 1 .289-.459l3-1.286a.51.51 0 0 1 .395 0z"
  })));
};
export default SvgMakeAdmin;